import '../styles/error-modal.css'

function ErrorModal({ message, onClose }) {
  return (
    <div className="error-modal-overlay" onClick={onClose}>
      <div className="error-modal" onClick={(e) => e.stopPropagation()}>
        <div className="error-modal-header">
          <h3>Error</h3>
          <button className="error-modal-close" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
        <div className="error-modal-content">
          <p>{message}</p>
        </div>
        <div className="error-modal-footer">
          <button className="error-modal-button" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  )
}

export default ErrorModal

